function FormatMoney(value: number | undefined): string {
    if (value && !isNaN(value)) {
        return Number(value)?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) || '';
    } else {
        return value?.toString() || '';
    }
}

export default FormatMoney;